import { Lock } from 'lucide-react';

import { useTranslation } from 'react-i18next';

export function SectionHeader({ icon: Icon, title }) {
  return (
    <div className="flex items-center gap-3 mb-5">
      <div
        className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        style={{ background: 'var(--glass-bg-active)' }}
      >
        <Icon className="h-[18px] w-[18px]" style={{ color: 'var(--theme-accent)' }} />
      </div>
      <h2 className="text-lg font-semibold" style={{ color: 'var(--theme-text)' }}>{title}</h2>
    </div>
  );
}

export function SubLabel({ icon: Icon, children }) {
  return (
    <div className="flex items-center gap-2 mb-2.5 mt-6">
      {Icon && <Icon className="h-3.5 w-3.5" style={{ color: 'var(--theme-textSecondary)' }} />}
      <span className="text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--theme-textSecondary)' }}>
        {children}
      </span>
    </div>
  );
}

export function PremiumBadge() {
  const {
    t
  } = useTranslation();

  return (
    <span
      className="ml-auto px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide flex items-center gap-1 shrink-0"
      style={{ background: 'var(--theme-accent)', color: '#fff', opacity: 0.85 }}
      data-testid="premium-badge"
    >
      <Lock className="h-2.5 w-2.5" />
      {t('generated.settingshelpers_pro_15a2')}
    </span>
  );
}
